import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../integration.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-successful',
  templateUrl: './successful.component.html',
  styleUrls: ['./successful.component.css']
})
export class SuccessfulComponent implements OnInit {

  constructor(private _integrationService:IntegrationService,private router:Router) { }

  ngOnInit() {
    this._integrationService.showNavSubject.next(true)
  }

  navigate(){
    window.open('https://my.subscrybe.app/dashboard')
  }

}
